import React from "react";
import { useHistory } from "react-router-dom";

import Card from "../../common/card/card";
import { ROUTES } from "../../constants/routes.constants";
import Button from "../button/button.component";


import "./access-denied.component.scss";
import appConfig from "../../config/app.config";

const staticAssetsUrl = appConfig.staticAssetsUrl;

const AccessDenied = () => {

  const history = useHistory();

  return (
    <Card
      cardClass="access-denied-card"
    >
      <div className="access-denied">
        <div className="text-grp">
          <div className="message2">Please login first</div>
          <Button displayName="Login" onClick={() => history.push(ROUTES.LOGIN)} />
        </div>
        <div>
          <img src={staticAssetsUrl+"/access-denied.jpeg"} width="400" height="400" />
        </div>
      </div>
    </Card>
  );
};

export default AccessDenied;
